import axios from "axios";
import { API_URL } from "../../const";

/** ***************** ADD LEADS DETAILS START *********************** */
export const leadsDetailsAdd = (addData: JSON) => {
  const data = {
    CreateLeadsToken: addData,
  };
  const url = `${API_URL}CreateLeads`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** ADD LEADS DETAILS END *********************** */

/** ***************** UPDATE LEADS DETAILS START *********************** */
export const leadsDetailsUpdate = (updateData: JSON) => {
  const data = {
    UpdateLeadsToken: updateData,
  };
  const url = `${API_URL}UpdateLeads`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE LEADS DETAILS END *********************** */

/** ***************** GET LEADS DETAILS START *********************** */
export const leadsListGet = (listData: any) => {
  const data = {
    FetchLeadsToken: listData,
  };
  const url = `${API_URL}FetchLeadsDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET LEADS DETAILS END *********************** */

/** ***************** FETCH LEADS DETAILS START *********************** */ //?
export const leadsFetchData = (fetchData: any) => {
  const data = {
    GetDepartmentToken: fetchData,
  };
  const url = `${API_URL}FetchDepartmentDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH LEADS DETAILS END *********************** */

/** ***************** DELETE LEADS DETAILS START *********************** */
export const leadsDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteLeadsToken: deleteData,
  };
  const url = `${API_URL}DeleteLeads`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** DELETE LEADS DETAILS END *********************** */

/** ***************** GET LEADS DETAILS START *********************** */
export const leadsListForAll = (listData: any) => {
  const data = {
    GetAllLeadsPaginationToken: listData,
  };
  const url = `${API_URL}GetAllLeadsDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET LEADS DETAILS END *********************** */

/** ***************** GET LIST STATUS DROPDOWN DETAILS START *********************** */
export const StatusListForAll = (listData: any) => {
  const data = {
    GetAllLeadStatusListToken: listData,
  };
  const url = `${API_URL}GetAllStatus`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET GET LIST STATUS DROPDOWN DETAILS END *********************** */

/** ***************** GET LIST PRODUCT DROPDOWN DETAILS START *********************** */
export const ProductDropdownListForAll = (listData: any) => {
  const data = {
    GetAllProductDropdownListToken: listData,
  };
  const url = `${API_URL}GetAllDropdownProduct`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET PRODUCT LIST DROPDOWN DETAILS END *********************** */

/** ***************** GET LIST PRODUCT DROPDOWN DETAILS START *********************** */
export const leadSourceDropdownListDetails = (listData: any) => {
  const data = {
    FetchAllLeadsSourceDetailsToken: listData,
  };
  const url = `${API_URL}FetchAllLeadsSourceDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET PRODUCT LIST DROPDOWN DETAILS END *********************** */

/** ***************** SEARCH PRELEAD LIMIT  START *********************** */
export const SearchPreleadListDetails = (listData: any) => {
  const data = {
    SearchPreLeadMasterToken: listData,
  };
  const url = `${API_URL}SearchPreLeadMasterLimit`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *****************SEARCH PRELEAD LIMIT  END *********************** */

/** ***************** FETCH PRODUCT lEADS LIMIT  START *********************** */
export const FetchDocumentListDetails = (listData: any) => {
  const data = {
    FetchAllDocumentToken: listData,
  };
  const url = `${API_URL}FetchAllDocument`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH PRODUCT lEADS LIMIT  END *********************** */

/** ***************** ADD DOCUMENT DETAILS START *********************** */
export const documentDetailsAdd = (addData: JSON) => {
  const data = {
    LeadAttachmentAddToken: addData,
  };
  const url = `${API_URL}CreateLeadAttachment`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** ADD DOCUMENT DETAILS END *********************** */

export const appliedLoanDetailAPI = (payload: any) => {
  const data = {
    UpdateLoanAppliedToken: payload,
  };
  const url = `${API_URL}UpdateLoanApplied`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};

/*****************  FETCH LEAD APPLIED LOG DETAILS START  *******************/
export const fetchListLeadAppliedLog = (payload: any) => {
  const data = {
    getLeadAppliedLogToken: payload,
  };
  const url = `${API_URL}getLeadAppliedLogDetails`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};

/*****************  FETCH SALE APPLIED LOG DETAILS START  *******************/
export const fetchListSaleAppliedLog = (payload: any) => {
  const data = {
    getSaleAppliedLogToken: payload,
  };
  const url = `${API_URL}getSaleAppliedLogDetails`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
/*****************  FETCH SALE APPLIED LOG DETAILS END  *******************/

/** ***************** UPDATE LEADS DOCUMENT DETAILS START *********************** */
export const leadsDocDetailsUpdate = (updateData: JSON) => {
  const data = {
    UpdateAllDocumentToken: updateData,
  };
  const url = `${API_URL}UpdateAllDocument`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE LEADS DOCUMENT DETAILS END *********************** */

/** ***************** GET LEADS DOCUMENT DETAILS START *********************** */
export const leadsDocListGet = (listData: any) => {
  const data = {
    GetAllDocumentToken: listData,
  };
  const url = `${API_URL}GetAllDocument`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET LEADS DOCUMENT DETAILS END *********************** */

/** ***************** FETCH LEADS DOCUMENT DETAILS START *********************** */
export const leadsDocGetData = (fetchData: any) => {
  const data = {
    GetBranchToken: fetchData,
  };
  const url = `${API_URL}FetchAllDocument`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH LEADS DOCUMENT DETAILS END *********************** */

/** ***************** DELETE LEADS DOCUMENT DETAILS START *********************** */
export const leadsDocDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteDocumentToken: deleteData,
  };
  const url = `${API_URL}DeleteDocument`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** DELETE LEADS DOCUMENT DETAILS END *********************** */

/** ***************** GET LEAD APPLIED  LIST DETAILS START *********************** */
export const getLeadAppliedListGet = (deleteData: any) => {
  const data = {
    GetLeadAppliedToken: deleteData,
  };
  const url = `${API_URL}GetLeadAppliedDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET LEAD APPLIED  LIST DETAILS DETAILS END *********************** */

/** *****************GET LEAD APPLIED  LIST  DETAILS START *********************** */
export const sicDetailsFetch = (deleteData: any) => {
  const data = {
    GetSicToken: deleteData,
  };
  const url = `${API_URL}sicGet`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET LEAD APPLIED  LIST  DETAILS END *********************** */

/** ***************** ADD STATUS DETAILS START *********************** */
export const addStatusDetailsApi = (addData: JSON) => {
  const data = {
    statusCreateToken: addData,
  };
  const url = `${API_URL}statusCreate`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** ADD STATUS DETAILS END *********************** */

/** ***************** UPDATE STATUS DETAILS START *********************** */
export const updateStatusDetailsApi = (updateData: JSON) => {
  const data = {
    UpdateStatusToken: updateData,
  };
  const url = `${API_URL}statusUpdate`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE STATUS DETAILS END *********************** */

/*************** LENDER APPLIED DETAILS DELETE START *************** */
export const lenderAppliedDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteLenderAppliedJsonToken: deleteData,
  };
  const url = `${API_URL}DeleteLenderApplied`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** LENDER APPLIED DETAILS DELETE END *************** */

/** ***************** SEARCH DASHBOARD LEADS START *********************** */
export const searchDashboardLeadsAPI = async (data: any) => {
  return await axios.post(`${API_URL}SearchDashboardLeads`, data, {
    headers: { "Content-type": "application/json" },
  });
};

export const deleteDashboardLeadsAPI = async (data: any) => {
  return await axios.post(`${API_URL}DeleteDashboardLeads`, data, {
    headers: { "Content-type": "application/json" },
  });
};

export const exportDashboardLeadsAPI = async (data: any) => {
  return await axios.post(`${API_URL}ExportDashboardLeads`, data, {
    headers: { "Content-type": "application/json" },
  });
};
